import { cn } from '@/lib/utils';
import { Skeleton } from '@/components/ui/Skeleton.tsx';
import { Card } from '@/components/ui/Card.tsx';
import { SectionColumnHeader } from '@/features/dashboard/bookingChanges/components/primitives';
import BillSectionSkeleton from './BillSectionSkeleton';

const SECTION_ROW_COUNTS = [1, 3, 4, 4, 2];

/** Szkielet ekranu uczestnika — lista sekcji plus stopka rozliczenia. */
const ParticipantBillViewSkeleton = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <Card className={cn('overflow-hidden', className)} {...props}>
    <div className="px-7 pt-0.5">
      <SectionColumnHeader />

      <div className="flex flex-col gap-3.5 pb-0.5">
        {SECTION_ROW_COUNTS.map((rowCount, index) => (
          <BillSectionSkeleton key={index} rowCount={rowCount} />
        ))}
      </div>
    </div>

    <div className="mt-[22px] border-t border-neutral-100 bg-neutral-50 pb-1 pt-[18px]">
      <div className="mx-7 flex flex-col gap-3">
        <div className="flex items-baseline justify-between gap-5 border-t border-neutral-200 pt-3">
          <Skeleton className="h-4 w-52" />
          <Skeleton className="h-6 w-32" />
        </div>
      </div>

      <div className="mt-4 flex items-center justify-between gap-5 border-t border-neutral-200 px-7 py-3.5">
        <Skeleton className="h-3.5 w-72" />
        <Skeleton className="h-8 w-36 rounded-lg" />
      </div>
    </div>
  </Card>
);

export default ParticipantBillViewSkeleton;
